import React, {useEffect, useRef} from 'react'
import {useTranslation} from 'react-i18next'
import {Alert} from 'reactstrap'

import {breadcrumbsStore} from 'appBase/TopNav'
import {getInfoAlert} from 'utils/resultsUtils'
import {CESIUM_3D_VIEW} from 'constants/constants'

function analyzeData(props) {
    let {simulation, resultsData} = props;
    const loading = props.loading || {resultsData: false};

    const noResults = !resultsData || resultsData.length === 0;
    const noSpacecrafts = !props.skipSimulationDataCheck &&
        (!simulation.simulationData || !simulation.simulationData.spacecrafts || simulation.simulationData.spacecrafts.length === 0);

    return {noResults: noResults, noSpacecrafts: noSpacecrafts, loading: loading.resultsData};
}

function createCesiumViewer(props) {
    const resultsData = props.resultsData.map(data => {
        const spacecrafts = [];
        const stations = [];

        for (let i = 0; i < 100; i++) {
            const root = `s.${i}`;
            if (!(`${root}.m.p.0` in data)) {
                break;
            }
            spacecrafts.push({
                'name' : props.simulation.simulationData.spacecrafts ?
                    props.simulation.simulationData.spacecrafts[i].name:
                    "",
                'motion': {
                    'position': [data[`${root}.m.p.0`], data[`${root}.m.p.1`], data[`${root}.m.p.2`]],
                    'orientation': [data[`${root}.m.o.0`], data[`${root}.m.o.1`], data[`${root}.m.o.2`], data[`${root}.m.o.3`]],
                    'linear-velocity': [data[`${root}.m.lv.0`], data[`${root}.m.lv.1`], data[`${root}.m.lv.2`]],
                    'angular-velocity': [data[`${root}.m.av.0`], data[`${root}.m.av.1`], data[`${root}.m.av.2`]]
                },
                'construction': {
                    'mass': data[`${root}.cn.m`]
                }
            });
        }
        if (props.simulation.simulationData.stations) {
            props.simulation.simulationData.stations.forEach(s => {
                stations.push({
                    'name': s.name,
                    'latitude': s.location[0],
                    'longtitude': s.location[1]
                });
            });
        }

        return {
            'time': data.t + 'Z',   // adding UTC time zone back
            'spacecrafts': spacecrafts,
            'stations': stations
        };
    });

    let directLoader = new window.DirectDataProvider();
    window.orbitaGlobal = new window.OrbitaApp({
        planet: props.simulation.simulationData.planet || 'earth',
        converter : {
            converterFilterRange : 1
        },
        loader: directLoader,
        // onBack: props.onBack
    });
    directLoader.setData(resultsData);
}

function destroyCesiumViewer() {
    if (window.orbitaGlobal && window.orbitaGlobal._viewer) {
        try {
            window.orbitaGlobal._viewer.destroy();
        } catch (e) {
            console.error(e);
        }
    }
}

function Cesium3dView(props) {

    const {simulation, resultsData} = props;

    const simulationId = useRef(simulation && simulation.id);
    const resultsDataLength = useRef(resultsData && resultsData.length);
    
    const {t} = useTranslation();

    const {noResults, noSpacecrafts, loading} = analyzeData(props);
    const infoAlertData = getInfoAlert(simulation, noResults, noSpacecrafts, loading, t);
    const infoAlert = infoAlertData &&
        <Alert className="mb-0" color={infoAlertData.type}>{infoAlertData.info}</Alert>;


    breadcrumbsStore.register(CESIUM_3D_VIEW);
    useEffect(() => {
        breadcrumbsStore.set(CESIUM_3D_VIEW, {name: t('appEvent.views.solutionViews.Cesium3dView.3dTrajectory'), back: 1, nonBlocking: true}, true);
    });

    useEffect(() => {
        if (simulation?.id !== simulationId.current || resultsData?.length !== resultsDataLength.current) {
            simulationId.current = simulation?.id;
            resultsDataLength.current = resultsData?.length;
            destroyCesiumViewer();
        }

        const {noResults, noSpacecrafts, loading} = analyzeData(props);
        if (!noResults && !noSpacecrafts && !loading) {
            createCesiumViewer(props);
        }

        return () => {
            destroyCesiumViewer();
        };

    }, [simulation, resultsData]);

    return (
        <div id="content">
            {infoAlert}
            <div id="app">
                <div id="cesiumContainer">

                </div>
                <div id="orbitaLeftWidgetToolbar"></div>
                <div id="orbitaRightWidgetToolbar"></div>
                <div id="timeline"></div>
                <div>
                    <form name="simulationParams">
                    </form>
                </div>
                <div id="toolbars">
                    <div className="toolbar" id="start-toolbar"></div>
                    <div className="toolbar" id="orbita-toolbar"></div>
                </div>
            </div>
        </div>);
}

export default Cesium3dView;